export const wtProfile = {
  analyticsSearch: [           
      {
        name: "First name",
        id: "FirstName",
        data: "FirstName",
        ishidden: false,
        iscalculated:false,
        position:"left",
        issortable:false,
        isfilterable:false
      },
       {
         name: "Last name",
         id: "LastName",
         data: "LastName",
         ishidden: false,
         iscalculated:false,
         position:"left",
         issortable:false,
         isfilterable:false
       },
       {
         name: "Email",
         id: "EmailAddress",
         data: "{EmailAddress}",
         ishidden: false,
         iscalculated:false,
         position:"left",
         issortable:false,
         isfilterable:false
       },
        {
          name: "Center",
          id: "Center",
          data: "Center",
          ishidden: false,
          iscalculated:false,
          position:"left",
          issortable:false,
          isfilterable:false
        },
        {
          name: "Profile language",
          id: "LanguageName",
          data: "LanguageName",
          ishidden: false,
          iscalculated:false,
          position:"left",
          issortable:false,
          isfilterable:false
        },
      //{
      //    name: "Member",
      //    id: "User",
      //    data: "{USERNAME}",
      //    ishidden: false,
      //    iscalculated:false,
      //    position:"left",
      //    issortable:true,
      //    isfilterable:true
      //},
      {
        name: "Score",
        id: "Score",
        data: "Score",
        ishidden: false,
        iscalculated:false,
        position:"left",
        issortable:true,
        isfilterable:true
      },      
      {
        name: "# Turns",
        id: "NumTurns",
        data: "NumTurns",
        ishidden: false,
        iscalculated:false,
        position:"left",
        issortable:true,
        isfilterable:true
      },      
      {
        name: "Date Started",
        id: "CreationDate",
        data: "{DATETIME}",
        ishidden: false,
        iscalculated:false,
        position:"left",
        issortable:true,
        isfilterable:true
      },
      {
        name: "Product Name",
        id: "ProductName",
        data: "ProductName",
        ishidden: false,
        iscalculated:false,
        position:"left",
        issortable:true,
        isfilterable:true
      },
      {
        name: "Transcript",
        id: "Transcript",
        data: "{METHOD:doTranscript}",
        ishidden: false,
        canhide:false,
        iscalculated:true,
        icon: "file-alt",
        position:"center",
        issortable:false,
        isfilterable:false
      }
  ],
  assignSummary: [
      {
        name: "Member",
        id: "FullUser",
        data: "FullUser",
        ishidden: false,
        iscalculated:false,
        position:"left",
        issortable:true,
        isfilterable:true,
        canhide:false
      },   
  ],
  myInbox: [
     {
       name: "Date",
       id: "DeliveryTime",
       data: "{DATETIME}",
       ishidden: false,
       iscalculated:false,
       position:"left",
       issortable:true,
       isfilterable:true
     },
     {
       name: "From",
       id: "FromName",
       data: "FromName",
       ishidden: false,
       iscalculated:false,
       position:"left",
       issortable:true,
       isfilterable:true
     },
     {
        name: "Subject",
        id: "Subject",
        data: "Subject",
        ishidden: false,
        iscalculated:false,
        position:"left",
        issortable:true,
        isfilterable:true
     }
    
  ],
  mySent: [
     {
       name: "Date",
       id: "MessageDate",
       data: "{DATETIME}",
       ishidden: false,
       iscalculated:false,
       position:"left",
       issortable:true,
       isfilterable:true
     },
     {
       name: "Subject",
       id: "Subject",
       data: "Subject",
       ishidden: false,
       iscalculated:false,
       position:"left",
       issortable:true,
       isfilterable:true
     }
    
  ],
  myTrainingPlans: [
      {
        name: "Name",
        id: "CurriculumName",
        data: "{METHOD:doEdit}",
        ishidden: false,
        iscalculated:true,
        islink:true,
        position:"left",
        issortable:true,
        isfilterable:true,
      },
      {
        name: "Internal Name",
        id: "InternalName",
        data: "InternalName",
        ishidden:false,
        iscalculated:false,
        position:"left",
        issortable:true,
        isfilterable:true
      },
      {
        name: "Last Modified",
        id: "ModifiedDate",
        data: "{DATE}",
        ishidden:false,
        iscalculated:false,
        position:"left",
        issortable:true,
        isfilterable:false
      },
      {
        name: "Duplicate",
        id: "duplicate",
        data: "{METHOD:doDuplicate}",
        ishidden: false,
        iscalculated:true,
        icon: "copy",
        position:"center",
        issortable:false,
        isfilterable:false
      },
      {
        name: "Delete",
        id: "delete",
        data: "{METHOD:doDelete}",
        ishidden: false,
        iscalculated:true,
        icon: "times",
        position:"center",
        issortable:false,
        isfilterable:false
      }
  ],
  orgAdmins: [
     {
       name: "Member",
       id: "User",
       data: "{USERNAME}",
       ishidden: false,
       iscalculated:false,
       position:"left",
       issortable:true,
       isfilterable:false
     },
     {
       name: "Delete",
       id: "delete",
       data: "{METHOD:doDelete}",
       ishidden: false,
       iscalculated:true,
       icon: "times",
       position:"center",
       issortable:false,
       isfilterable:false
     }
  ],
  orgOrderHistory: [
      {
        name: "Date",
        id: "OrderDate",
        data: "{DATE}",
        ishidden: false,
        iscalculated:false,
        position:"left",
        issortable:true,
        isfilterable:true
      },
      {
         name: "Pool Name",
         id: "LicensePoolName",
         data: "LicensePoolName",
         ishidden: false,
         iscalculated:false,
         position:"left",
         issortable:true,
         isfilterable:true
      },
      {
        name: "Amount",
        id: "InvoiceAmt",
        data: "InvoiceAmt",
        ishidden: false,
        iscalculated:false,
        position:"left",
        issortable:true,
        isfilterable:true
      },
      {
        name: "# Bundles",
        id: "TotalBundles",
        data: "TotalBundles",
        ishidden: false,
        iscalculated:false,
        position:"left",
        issortable:true,
        isfilterable:true
      },
      {
        name: "# Products",
        id: "TotalProducts",
        data: "TotalProducts",
        ishidden: false,
        iscalculated:false,
        position:"left",
        issortable:true,
        isfilterable:true
      },
       {
         name: "Details",
         id: "ViewDetails",
         data: "{METHOD:doViewDetails}",
         icon: "info-circle",
         ishidden: false,
         iscalculated:true,
         position:"center",
         issortable:false,
         isfilterable:false
       }
  ],
  groupLog: [
     {
       name: "Date",
       id: "OperationDate",
       data: "{DATETIME}",
       ishidden: false,
       iscalculated:false,
       position:"left",
       issortable:true,
       isfilterable:true
     },
     {
       name: "Member",
       id: "User",
       data: "user",
       ishidden: false,
       iscalculated:false,
       position:"left",
       issortable:true,
       isfilterable:true
     },
     {
       name: "Operation",
       id: "OperationText",
       data: "OperationText",
       ishidden: false,
       iscalculated:false,
       position:"left",
       issortable:true,
       isfilterable:true
     }
  ],
  groupPrivileges: [
    {
      name: "Member",
      id: "Name",
      data: "Name",
      ishidden: false,
      iscalculated:false,
      position:"left",
      issortable:true,
      isfilterable:true,
      canhide:false
    },
    {
      name: "Group Privileges",
      id: "GroupPrivs",
      data: "GroupPrivs",
      ishidden: false,
      iscalculated:false,
      position:"left",
      issortable:false,
      isfilterable:true
    },
    {
      name: "Edit",
      id: "edit",
      data: "{METHOD:doEdit}",
      ishidden: false,
      iscalculated:true,
      icon: "edit",
      position:"center",
      issortable:false,
      isfilterable:false
    }
  ],
  poolLog: [
      {
        name: "Date",
        id: "OperationDate",
        data: "{DATETIME}",
        ishidden: false,
        iscalculated:false,
        position:"left",
        issortable:true,
        isfilterable:true
      },
      {
        name: "Member",
        id: "User",
        data: "{USERNAME}",
        ishidden: false,
        iscalculated:false,
        position:"left",
        issortable:true,
        isfilterable:true
      },
      {
        name: "Operation",
        id: "OperationText",
        data: "OperationText",
        ishidden: false,
        iscalculated:false,
        position:"left",
        issortable:true,
        isfilterable:true
      }
  ],
  poolMembers: [
      {
        name: "Member",
        id: "User",
        data: "{USERNAME}",
        ishidden: false,
        iscalculated:false,
        position:"left",
        issortable:true,
        isfilterable:true,
        canhide:false
      },   
      {
        name: "Status",
        id: "Status",
        data: "{MEMBERSTATUS}",
        ishidden: false,
        iscalculated:false,
        position:"left",
        issortable:true,
        isfilterable:true
      },
      {
        name: "Last Login",
        id: "LastLoginDate",
        data: "{DATETIME}",
        ishidden:false,
        iscalculated:false,
        position:"left",
        issortable:true,
        isfilterable:true
      },
        {
          name: "Privilege",
          id: "AdminLevel",
          data: "AdminLevel",
          ishidden: false,
          iscalculated:false,
          position:"left",
          issortable:true,
          isfilterable:true
        },
       {
         name: "Disabled",
         id: "IsDisabled",
         data: "IsDisabled",
         ishidden: false,
         iscalculated:false,
         position:"left",
         issortable:true,
         isfilterable:true
       },
     
  ],
  poolPrivileges: [
     {
       name: "Member",
       id: "Name",
       data: "Name",
       ishidden: false,
       iscalculated:false,
       position:"left",
       issortable:true,
       isfilterable:true,
       canhide:false
     },
     {
       name: "Pool Privileges",
       id: "PoolPriv",
       data: "PoolPriv",
       ishidden: false,
       iscalculated:false,
       position:"left",
       issortable:true,
       isfilterable:true
     },
     {
       name: "Group Privileges",
       id: "GroupPrivs",
       data: "GroupPrivs",
       ishidden: false,
       iscalculated:false,
       position:"left",
       issortable:false,
       isfilterable:true
     },
     {
       name: "Edit",
       id: "edit",
       data: "{METHOD:doEdit}",
       ishidden: false,
       iscalculated:true,
       icon: "edit",
       position:"center",
       issortable:false,
       isfilterable:false
     }
  ],
  poolProducts: [
     {
       name: "Product Name",
       id: "ProductExtendedName",
       data: "ProductExtendedName",
       ishidden: false,
       iscalculated:false,
       position:"left",
       issortable:true,
       isfilterable:true
     },
     {
        name: "# Left",
        id: "LicensesNumber",
        data: "LicensesNumber",
        ishidden: false,
        iscalculated:false,
        position:"left",
        issortable:true,
        isfilterable:true
     },
     {
        name: "Term",
        id: "ProductExp",
        data: "ProductExp",
        ishidden: false,
        iscalculated:false,
        position:"left",
        issortable:true,
        isfilterable:true
     },
      {
        name: "# Members",
        id: "LicenseUsers",
        data: "LicenseUsers",
        ishidden: false,
        iscalculated:false,
        position:"left",
        issortable:true,
        isfilterable:true
      },
      {
        name: "Members",
        id: "users",
        data: "{METHOD:doUsers}",
        ishidden: false,
        iscalculated:true,
        icon: "users",
        position:"center",
        issortable:false,
        isfilterable:false
      },
     {
        name: "Details",
        id: "edit",
        data: "{METHOD:doEdit}",
        ishidden: false,
        iscalculated:true,
        icon: "edit",
        position:"center",
        issortable:false,
        isfilterable:false
     }
  ],
  trainingPlanSummary: [
    {
      name: "Member",
      id: "user",
      data: "{USERNAME}",
      ishidden: false,
      iscalculated:false,
      position:"left",
      issortable:true,
      isfilterable:true,
      canhide:false
    },
    {
       name: "Status",
       id: "Status",
       data: "Status",
       ishidden: false,
       iscalculated:false,
       position:"left",
       issortable:true,
       isfilterable:false
    },
    {
       name: "Lessons Completed",
       id: "LessonsCompleted",
       data: "LessonsCompleted",
       ishidden: false,
       iscalculated:false,
       position:"left",
       issortable:true,
       isfilterable:false
     },
    {
       name: "History",
       id: "history",
       data: "{METHOD:doHistory}",
       ishidden: false,
       iscalculated:true,
       icon: "clipboard-list",
       position:"center",
       issortable:false,
       isfilterable:false
    },
    {
       name: "Reset",
       id: "reset",
       data: "{METHOD:doReset}",
       ishidden: false,
       iscalculated:true,
       icon: "sync",
       position:"center",
       issortable:false,
       isfilterable:false
    },
    {
      name: "Remove",
      id: "remove",
      data: "{METHOD:doRemove}",
      ishidden: false,
      iscalculated:true,
      icon: "times",
      position:"center",
      issortable:false,
      isfilterable:false
    }
  ]
}
